const useDocumentTitle = (title) => {
  document.title = title;
};

export { useDocumentTitle };
